export default function traverse(data, matchers = []) {
    return traverseInternal(data, matchers, new Map());
}
function traverseInternal(value, matchers, visited = new Map()) {
    if (visited.has(value)) {
        return visited.get(value);
    }
    visited.set(value, undefined);
    const continueTraverse = (value)=>{
        return traverseInternal(value, matchers, visited);
    };
    let matched = false;
    let result = value;
    for(let i = 0; i < matchers.length; i++){
        const [matches, setter] = matchers[i];
        if (matches(value) && setter) {
            matched = true;
            result = setter(value, continueTraverse);
            break;
        }
    }
    if (matched) {
        visited.set(value, result);
        return result;
    }
    switch(true){
        case Array.isArray(value):
            result = value.map(continueTraverse);
            break;
        case value && Object.getPrototypeOf(value) === Object.prototype:
            const copy = {};
            for(const key in value){
                if (value.hasOwnProperty(key)) {
                    copy[key] = continueTraverse(value[key]);
                }
            }
            result = copy;
            break;
    }
    visited.set(value, result);
    return result;
}

//# sourceMappingURL=traverse.js.map